// @ts-nocheck
import React, { Component } from 'react';

import TicketAdditionalInfo from './additionalInfo/ticketAdditionalInfo';
import TicketBarcode from './barcode/barcode';

import styles from './ticket.module.scss';
import { getHeaderBackgroundColor, getTextFontColor, getTicketBackgroundColor } from '@/v2/helpers/ticketColors/ticketColorsHelper.ts';
import { EventModel } from '@/v2/models/eventModel.ts';
import { TicketCardv2 } from '@ticketmaster/global-design-system';
import { TicketModel } from '@/v2/models/ticketModel.ts';
import TicketHeader from '@/v2/wallet/tickets/ticket/header/header.tsx';
import TicketPortal from '@/v2/wallet/tickets/ticket/portal/portal.tsx';
import { RedemptionAvailabilityModel } from '@/v2/models/multiEventEnvelopeModel.ts';

type Props = {
  activeToken: string;
  ticket: TicketModel;
  event: EventModel;
  redemptionAvailability: RedemptionAvailabilityModel;
};

type State = any;

class Ticket extends Component<Props, State> {
  render() {
    const { ticket, event, activeToken, redemptionAvailability } = this.props;
    const ticketBackgroundColor = getTicketBackgroundColor(ticket);
    const headerBackgroundColor = getHeaderBackgroundColor(ticket);
    const textFontColor = getTextFontColor(ticket);
    const status = ticket.voidedAt ? "disabled" : "primary";

    return (
      <TicketCardv2
        status={status}
        {...(!!ticketBackgroundColor) && { backgroundColor: ticketBackgroundColor }}
        {...(!!headerBackgroundColor && !!textFontColor) && { wayfindingColors: { background: headerBackgroundColor, foreground: textFontColor } }}
      >
        <TicketHeader ticket={ticket}/>
        <div className={styles.ticketMiddleSection}>
          <TicketBarcode activeToken={activeToken} ticket={ticket} event={event} redemptionAvailability={redemptionAvailability}/>
        </div>
        {!ticket.voidedAt &&
            <div className={styles.ticketBottomSection}>
                <TicketPortal ticket={ticket}/>
                <TicketAdditionalInfo ticket={ticket}/>
            </div>
        }
      </TicketCardv2>
    );
  }
}

export default Ticket;
